var render, staticRenderFns
import script from "./BillingDetailView.vue?vue&type=script&lang=ts"
export * from "./BillingDetailView.vue?vue&type=script&lang=ts"
import style0 from "./BillingDetailView.vue?vue&type=style&index=0&id=527e5242&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527e5242')) {
      api.createRecord('527e5242', component.options)
    } else {
      api.reload('527e5242', component.options)
    }
    
  }
}
component.options.__file = "src/views/billing/Billing/BillingDetailView.vue"
export default component.exports